<template>
  <section class="login-wrap p-0">
    <div class="image image-overlay" style="background-image: url('/img/bg.jpg')"></div>
    <div class="container">
      <div class="row justify-content-center align-items-center vh-100">
        <div class="col-md-6 col-lg-5 pt-10 pb-5">
          <div class="accordion-group accordion-group-portal">
            <div class="accordion">
              <div class="accordion-control" aria-expanded="true">
                <h5>Восстановление пароля</h5>
              </div>
              <div class="accordion-content collapse show">
                <div class="accordion-content-wrapper">
                  <form @submit.prevent="validateBeforeSubmit">
                    <div class="form-group">
                      <label class="control-label" for="passwordresetform-password">Новый пароль</label>
                      <input type="password"
                              id="passwordresetform-password"
                              class="form-control"
                              :class="{'is-valid': passwordFlags.valid, 'is-invalid': errors.has('password') }"
                              name="password"
                              v-model="password"
                              v-validate="'required|min:6|verify_password'"
                      >
                      <p v-if="err.hasOwnProperty('password')" class="text-danger">
                        {{err.password}}
                      </p>
                      <p v-if="err.hasOwnProperty('token')" class="text-danger">
                        {{err.token}}
                      </p>
                    </div>
                    <div class="form-group">
                      <button type="submit" class="btn btn-primary btn-block">Отправить</button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
  import { mapFields } from 'vee-validate';
  import { mapActions } from 'vuex';

  export default {
    name: "PasswordReset",
    data() {
      return {
       password: '',
       err: '',
      }
    },
    methods: {
      validateBeforeSubmit() {
        this.$validator.validateAll().then((result) => {
          if (result) {
            this.PASSWORD_RESET({token: this.$route.query.token, password: this.password}).then(data => {
              if (data.ok) {
                this.$router.push('/');
              } else {
                this.err = data.body.error;
              }
            });
          }
        });
      },
      ...mapActions({
        PASSWORD_RESET: 'auth/PASSWORD_RESET'
      }),
    },
    computed: {
      ...mapFields({
        passwordFlags: 'password',
      }),
    },
  }
</script>

<style scoped>

</style>
